export default __webpack_public_path__ + "static/media/Darkblade's Bracers of the Dark Pact.cbd4a576.jpg";